<template>
    <label :for="for_id" class="flex items-center select-none">
        <input :id="for_id" hidden type="checkbox" :checked="checked" :disabled="isDisabled">
        <span
            class="block rounded-full border border-next-dark-gray mr-2 cursor-pointer shrink-0"
            :class="[checked ? 'border-next-orange bg-next-orange':'',isDisabled?'border-next-gray-md-dark': '', checkClass ]"></span>
        <span class="text-left whitespace-pre-wrap"><slot></slot></span>
    </label>
</template>

<script lang="ts">
import {Options, Vue} from 'vue-class-component';
import NextButton from "@/components/NextButton.vue";

@Options({
    name:'Checkbox',
    components: {
        NextButton,
    },
    props: {
        for_id: [Number, String],
        checkClass: String,
        checked: Boolean,
    },
})
export default class Checkbox extends Vue {
    get isDisabled(){
        return !!this.$attrs['disabled']
    }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
